import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  temporarilyDisableCheckboxes() {
    const distanceCheckboxes = document.querySelectorAll('.distance-checkbox');

    distanceCheckboxes.forEach(checkbox => checkbox.style.pointerEvents = 'none');

    setTimeout(() => {
      distanceCheckboxes.forEach(checkbox => checkbox.style.pointerEvents = 'auto');
    }, 5000);
  }
}
